
const CHIAVE = 'unimatic:quiz:scelte';
// Il trattino non e' obbligatorio: a catalogo ci sono handle di una parola sola (utcase,
// utcase8) e pretenderlo li faceva scartare in silenzio, lasciando la pagina esiti vuota.
const LISTA_DI_HANDLE = /^[a-z0-9]+(?:-[a-z0-9]+)*(?:\s*,\s*[a-z0-9]+(?:-[a-z0-9]+)*)*$/;

function metti_da_parte() {
  const scelte = [...document.querySelectorAll('.quiz .globo-form input:checked')]
    .map((campo) => campo.value.trim())
    .filter((valore) => LISTA_DI_HANDLE.test(valore));

  if (scelte.length) sessionStorage.setItem(CHIAVE, JSON.stringify(scelte));
}

function modelli_migliori() {
  let scelte;
  try {
    scelte = JSON.parse(sessionStorage.getItem(CHIAVE) || '[]');
  } catch {
    return null;
  }

  const liste = scelte
    .map((riga) => riga.split(',').map((handle) => handle.trim()).filter(Boolean))
    .filter((lista) => lista.length > 0);

  if (!liste.length) return null;

  const punteggio = new Map();
  for (const lista of liste) {
    for (const handle of new Set(lista)) {
      punteggio.set(handle, (punteggio.get(handle) ?? 0) + 1);
    }
  }

  const massimo = Math.max(...punteggio.values());
  return {
    modelli: [...punteggio].filter(([, punti]) => punti === massimo).map(([handle]) => handle),
    massimo,
    risposte: liste.length,
  };
}

function mostra_risultati(griglia) {
  const schede = [...griglia.querySelectorAll('[data-quiz-model]')];
  const esito = modelli_migliori();
  const senza_risposte = !esito;

  for (const scheda of schede) {
    scheda.hidden = senza_risposte ? false : !esito.modelli.includes(scheda.dataset.quizModel);
  }

  const avviso = document.querySelector('[data-quiz-nessun-esito]');
  if (avviso) avviso.hidden = senza_risposte || esito.massimo >= esito.risposte;

  griglia.dataset.quizPronto = 'si';
}

document.addEventListener('change', (evento) => {
  if (evento.target.closest('.quiz .globo-form')) metti_da_parte();
});

const griglia = document.querySelector('[data-quiz-results]');
if (griglia) mostra_risultati(griglia);
